const typeMap = {
  pdf: "application/pdf",
  xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
}

export default function (data, type, filename) {
  if (!typeMap[type]) {
    throw new Error(`Unknown file type: ${type}`)
  }
  const download = document.createElement("a")
  download.href = `data:${type};base64,${data}`
  download.download = filename
  download.click()
}
